import React from "react";

const Footer = () => {
 return (
  <footer className="border-top border-secondary" style={{fontSize:'15px'}}>
    <div className="navbar navbar-expand-lg p-2 justify-content-center">
      <div className="navbar-nav mb-3">
        <a className="nav-item nav-link m-3 mb-0" style={{color:'#0A243E'}} href="https://www.cgd.pt/Site/CXA/CGD-Pensoes/Pages/Contactos.aspx" target="_blank" rel="noopener noreferrer">Contactos</a>
        <a className="nav-item nav-link m-3 mb-0" style={{color:'#0A243E'}} href="https://www.cgd.pt/Site/CXA/CGD-Pensoes/Pages/Politica-de-Privacidade.aspx" target="_blank" rel="noopener noreferrer">Política de Privacidade</a>
        <a className="nav-item nav-link m-3 mb-0" style={{color:'#0A243E'}} href="https://www.cgd.pt/Site/CXA/CGD-Pensoes/Pages/Politica-de-Cookies.aspx" target="_blank" rel="noopener noreferrer">Política de Cookies</a>
        <a className="nav-item nav-link m-3 mb-0" style={{color:'#0A243E'}} href="https://www.cgd.pt/Site/CXA/CGD-Pensoes/Pages/Aviso-Legal.aspx" target="_blank" rel="noopener noreferrer">Aviso Legal</a>
        <a className="nav-item nav-link m-3 mb-0" style={{color:'#0A243E'}} href="https://www.livroreclamacoes.pt/" target="_blank" rel="noopener noreferrer">Livro de Reclamações</a>
      </div>
    </div>
    <div className="text-center p-3" style={{backgroundColor:'#C9D5E7', color:'#3F5B78', fontSize:'12px', lineHeight:'24px'}}>
      A CGD está registada junto do Banco de Portugal sob o n.º 35, da CMVM sob o n.º 125 e da ASF sob o nº 419501357.<br />
      2022 © Caixa Geral de Depósitos, SA. Todos os direitos reservados. <a style={{color:'#3F5B78'}} href="https://www.cgd.pt/ajuda/Seguranca/Condicoes-Utilizacao/Pages/Condicoes-Utilizacao.aspx" target="_blank" rel="noopener noreferrer">Condições de utilização</a>
    </div>
  </footer>
 );
};

export default Footer;
